import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/ModeratorDashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import ModeratorUserManagement from "../components/ModeratorUserManagement";
import video_icon from "../images/video_icon.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import user_management from "../images/user_management.png";
import license_management from '../images/license_management.png';
import tutorials from "../images/tutorials.png";

const ModeratorDashboard = () => {
  const [activeItem, setActiveItem] = useState("user_management");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate(); // Initialize useNavigate

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const moderatorMenuItems = [
    { icon: video_icon, label: "Manage Videos ", key: "video_management" },
    { icon: user_management, label: "Manage Users", key: "user_management" },
    { icon: license_management, label: "Manage Licenses", key: "license_management" },
    { icon: feedback, label: "Feedback", key: "feedback" },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true }
  ];
  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "video_management") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "user_management") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "license_management") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "video_management") {
      navigate("/moderator/video-management");
    } else if (item === "user_management") {
      navigate("/moderator/user-management"); 
    }
    else if (item === "feedback") {
      navigate("/moderator/feedback"); 
    }else if (item === "tutorials") {
      navigate("/admin/tutorials"); 
    }else if (item === "license_management") {
      navigate("/moderator/license-management"); 
    }
  };
    // Determine which parts of the header to show based on the active menu item
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
       <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        onSearch={(query) => setSearchQuery(query)}
        showToggle={showToggle}
        searchQuery={searchQuery}
        showUserProfile={showUserProfile}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={moderatorMenuItems}
        />
        <div className="content">
        <ModeratorUserManagement/>
      </div>
      </main>
    </div>
  );
};

export default ModeratorDashboard;
